import { render, staticRenderFns } from "./KnivesetsView.vue?vue&type=template&id=b0a7c6f4&scoped=true&"
import script from "./KnivesetsView.vue?vue&type=script&lang=ts&"
export * from "./KnivesetsView.vue?vue&type=script&lang=ts&"
import style0 from "./KnivesetsView.vue?vue&type=style&index=0&id=b0a7c6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a7c6f4",
  null
  
)

export default component.exports